import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/png/logo-gsalt-while-right-text.png'
import _imports_1 from '@/assets/svg/entyvio_logo.svg'
import _imports_2 from '@/assets/svg/logo-takeda-white.svg'


const _withScopeId = n => (_pushScopeId("data-v-1251ee61"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar navbar-expand-lg navbar-dark fixed-top" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1))
const _hoisted_4 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent",
  ref: "navbarCollapse"
}
const _hoisted_5 = { class: "navbar-nav me-auto mb-2 mb-lg-0" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item divider-item d-none d-lg-block" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "divider" })
], -1))
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "navbar-right d-none d-lg-block" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo-entyvio",
    src: _imports_1
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo-takeda",
    src: _imports_2
  })
], -1))

import { useAuthStore } from '@/stores/auth'
import { Collapse } from 'bootstrap'
import { ref, } from 'vue'
import { useRouter } from 'vue-router'
import SafetyModal from './SafetyModal.vue'
import ReferencesModal from './ReferencesModal.vue'
import { moduleChoiceLogoReferences } from '@/data/modulechoice'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const config = require('../../../vuejs-app/vue.config.js');

const safetyModal = ref<InstanceType<typeof SafetyModal> | null>(null)
const referencesModal = ref<InstanceType<typeof ReferencesModal> | null>(null)

function showReferences() {
  referencesModal.value?.show()
}
const router = useRouter()

function collapseMenu() {
  const collapse = new Collapse('#navbarSupportedContent')
  collapse?.hide()
}

function openPDF() {
  window.open(`${process.env.BASE_URL}Entyvio-Abbreviated-Product-Information-dk.pdf`);
}

function openSafetyModal() {
  collapseMenu()

  safetyModal.value?.show()
}

async function logout() {
  const authStore = useAuthStore()

  await authStore.logout()
  router.push('/home')
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          onClick: showReferences,
          class: "logo-gsalt",
          src: _imports_0
        }),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: "/modules-choice",
                class: "nav-link",
                onClick: collapseMenu
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('header.home')), 1)
                ]),
                _: 1
              })
            ]),
            _hoisted_7,
            _createElementVNode("li", _hoisted_8, [
              _createElementVNode("button", {
                class: "btn-empty nav-link",
                onClick: openPDF
              }, _toDisplayString(_ctx.$t('header.prescribingInformation')), 1)
            ]),
            _createElementVNode("li", _hoisted_9, [
              _createElementVNode("button", {
                class: "btn-empty nav-link",
                onClick: openSafetyModal
              }, _toDisplayString(_ctx.$t('header.importantSafetyInformation')), 1)
            ])
          ])
        ], 512),
        _hoisted_10
      ])
    ]),
    _createVNode(ReferencesModal, {
      ref_key: "referencesModal",
      ref: referencesModal,
      references: Object.values(_unref(moduleChoiceLogoReferences))
    }, null, 8, ["references"]),
    _createVNode(SafetyModal, {
      ref_key: "safetyModal",
      ref: safetyModal
    }, null, 512)
  ], 64))
}
}

})